import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { growthAPI } from '../../lib/api';
import { toast } from 'sonner';

const PLATFORMS = [
  { key: 'twitter', label: 'X', color: 'bg-zinc-800 hover:bg-zinc-700' },
  { key: 'facebook', label: 'FB', color: 'bg-blue-600 hover:bg-blue-500' },
  { key: 'whatsapp', label: 'WA', color: 'bg-green-600 hover:bg-green-500' },
];

export default function ShareButton({ contentType, contentId, title, className = '' }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const appUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  const shareUrl = contentType === 'product'
    ? `${appUrl}/product/${contentId}`
    : contentType === 'creator'
    ? `${appUrl}/creator/profile/${contentId}`
    : `${appUrl}`;

  const shareText = title ? `Check out "${title}" on MMarketing!` : 'Check this out on MMarketing!';

  const handleShare = async (platform) => {
    let url;
    switch (platform) {
      case 'twitter': url = `https://x.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`; break;
      case 'facebook': url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`; break;
      case 'whatsapp': url = `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`; break;
      default: return;
    }
    window.open(url, '_blank', 'width=600,height=400');
    try { await growthAPI.trackShare(platform, contentType, contentId); toast.success('+5 points for sharing!'); } catch {}
    setOpen(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      try { await growthAPI.trackShare('copy', contentType, contentId); toast.success('Link copied! +5 points'); } catch {}
    } catch { toast.error('Failed to copy'); }
    setOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button onClick={() => setOpen(!open)} className="flex items-center gap-1 text-xs text-zinc-400 hover:text-white transition-colors" data-testid={`share-btn-${contentType}-${contentId}`}>
        <Share2 size={14} /> Share
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 bottom-full mb-2 z-50 bg-zinc-900 border border-zinc-700 p-2 flex gap-1.5 shadow-xl" data-testid="share-dropdown">
            {PLATFORMS.map(p => (
              <button key={p.key} onClick={() => handleShare(p.key)} className={`${p.color} text-white text-[10px] font-bold px-2.5 py-1.5 transition-colors`} data-testid={`share-${p.key}`}>
                {p.label}
              </button>
            ))}
            <button onClick={handleCopy} className="bg-zinc-700 hover:bg-zinc-600 text-white text-[10px] font-bold px-2.5 py-1.5 transition-colors" data-testid="share-copy">
              {copied ? <Check size={12} /> : <Copy size={12} />}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
